import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import axios from 'axios';

import MemberHeader from './parts/MemberHeader';
import MemberFooter from './parts/MemberFooter';

const Dashboard = () => {
  const setApp = useDispatch();
  const [excelGenerated,setExcelGenerated]  = useState(!1);

  const data = window.pagedata;

  useEffect(() => {
    axios.post(
      '/export/excel',
      { offset: moment().utcOffset() }
    ).then(() => {
      setExcelGenerated(1)
    });
    setApp({
      type: '_AUTH_LOGGED',
      payload: [window.auth.first_name, window.auth.last_name]
    });
  }, []);

  return (
    <>
      <section id="member-area">
        <MemberHeader title="Dashboard"/>
        <div id="breadcrumb">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-xs-12">
                <div className="breadcrumb-items">
                    <ul id="breadcrumbs" className="breadcrumbs">
                      <li>
                        <a
                          className="bread-link bread-home"
                          href="/"
                          title="Home"
                        >
                          Home/Map
                        </a>
                      </li>
                      <li>
                        <strong className="bread-current">Dashboard</strong>
                      </li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="dashboard-card" className="container dashboard-card">
          <div className="row">
            <div className="col-sm-6">
              <div className="card">
                <div className="card-body">
                  <h1 className="card-title">{data.study_stat[0] || 0}</h1>
                  <h5 className="card-text mb-4">
                    <i className="fa fa-eye"/> Total views of all datasets
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="card">
                <div className="card-body">
                  <h1 className="card-title">{data.study_stat[1] || 0}</h1>
                  <h5 className="card-text mb-4">
                    <i className="fa fa-download"/> Total of downloaded datasets
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card">
                <div className="card-body">
                  <h1 className="card-title">{data.total_datasets || 0}</h1>
                  <h5 className="card-text mb-4">
                    <i className="fa fa-file-archive-o"/>
                    {' Total datasets available'}
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card">
                <div className="card-body">
                  <h1 className="card-title">{data.total_public_users || 0}</h1>
                  <h5 className="card-text mb-4">
                    <i className="fa fa-users"/> Total of public users
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card">
                <div className="card-body">
                  <h1 className="card-title">{data.total_data_contributors || 0}</h1>
                  <h5 className="card-text mb-4">
                    <i className="fa fa-user-plus"/> Total of data contributors
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="member-block-style">

          <div className="container">
            <div className="row">
              <div className="col">
                <h5 className="member-block-title">
                  <i className="fa fa-list"/> Recent downloaded datasets:
                </h5>
                <table className="table table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col" style={{width:168}}>Datetime</th>
                      <th scope="col" style={{width:190}}>Downloaded by</th>
                      <th scope="col">Study title</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data.recent_downloads.map((d, i) => {
                        console.log('d', d);
                        return (
                          <tr key={i}>
                            <td>
                              {
                                moment
                                  .utc(d.downloadDatetime)
                                  .tz(moment.tz.guess())
                                  .fromNow()
                              }
                              <br/>
                              <small>
                                <b>
                                  {
                                    moment
                                      .utc(d.downloadDatetime)
                                      .tz(moment.tz.guess())
                                      .format('D MMM YYYY')
                                  }
                                </b>
                                {' '}
                                <i className="fa fa-clock-o"/>
                                {' '}
                                {
                                  moment
                                    .utc(d.downloadDatetime)
                                    .tz(moment.tz.guess())
                                    .format('hh:mm a')
                                }
                              </small>
                            </td>
                            <td>
                              <a href={`/member/account/${d.id}`}>
                                <b>
                                  {d.first_name} {d.last_name}
                                </b>
                              </a>
                              {
                                d.affiliation && (
                                  <>
                                    <br/><small>{`(${d.affiliation})`}</small>
                                  </>
                                )
                              }
                            </td>
                            <td>
                              <a href={`/study/${d.studyId}`}>
                                <b>{d.title}</b>
                              </a>
                              <br/>
                              <small>
                                <b>{'REASON: '}</b>
                                {d.reason}
                              </small>
                              <br/>
                              <small
                                style={{ opacity: 0.85 }}
                                dangerouslySetInnerHTML={{
                                  __html: `<b>DCA:</b> ${d.dca11b}`
                                }}
                              />
                            </td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
                <br/>
                {
                  excelGenerated && (
                    <a
                      href="/download/WILDMEAT_Database_download_log.xlsx"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-o"
                    >
                      <i className="fa fa-file-text-o"/>
                      {' Export all to an Excel file'}
                    </a>
                  )
                }
              </div>
            </div>
          </div>
        </div>

        <div className="member-block">

          <div className="container">
            <div className="row">
              <div className="col">
                <h5 className="member-block-title">
                  <i className="fa fa-list"/> Data contributors:
                </h5>
                <table className="table table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Affiliation</th>
                      <th scope="col">Email</th>
                      <th
                        scope="col"
                        className="text-center"
                        style={{ width: 88 }}
                      >
                        Verified?
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data.data_contributors.map((d,i)=>{
                        return (
                          <tr key={d.id}>
                            <td><a href={`/member/account/${d.id}`}><b>{`${d.first_name} ${d.last_name}`}</b></a></td>
                            <td>{d.affiliation}</td>
                            <td>{d.email}</td>
                            <td className="text-center">{d.is_verified ? <i className="text-success fa fa-check-circle"/> : <i className="text-warning fa fa-minus-circle"/>}</td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
                <br/><hr/>
                <h5 className="member-block-title"><i className="fa fa-list"/> Recent registered public users:</h5>
                <table className="table table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Datetime</th>
                      <th scope="col">Name</th>
                      <th scope="col">Affiliation</th>
                      <th scope="col">Email</th>
                      <th scope="col" className="text-center" style={{width:88}}>Verified?</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data.latest_users.map((d)=>{
                        return (
                          <tr key={d.id}>
                            <td>{moment.utc(d.user_registered).tz(moment.tz.guess()).fromNow()}</td>
                            <td><a href={`/member/account/${d.id}`}><b>{`${d.first_name} ${d.last_name}`}</b></a></td>
                            <td>{d.affiliation}</td>
                            <td>{d.email}</td>
                            <td className="text-center">{d.is_verified ? <i className="text-success fa fa-check-circle"/> : <i className="text-warning fa fa-minus-circle"/>}</td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
                <br/>
                <a href="/member/all" className="btn btn-o">View all users &nbsp;&nbsp;<i className="fa fa-long-arrow-right"/></a>
              </div>
            </div>
          </div>
        </div>

        {
          data.stat_studies.length ? (
            <div className="member-block-style">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <h5 className="member-block-title"><i className="fa fa-database"/> Your dataset{data.stat_studies.length > 1 ? 's' : ''}:</h5>

                    <div className="row dashboard-card">
                      <div className="col-sm-4">
                        <div className="card">
                          <div className="card-body">
                            <h1 className="card-title">{data.contributor_study_stat[0]}</h1>
                            <h5 className="card-text mb-4"><i className="fa fa-eye"/> Total views of your datasets</h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="card">
                          <div className="card-body">
                            <h1 className="card-title">{data.contributor_study_stat[1]}</h1>
                            <h5 className="card-text mb-4"><i className="fa fa-download"/> Total of your datasets downloaded</h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="card">
                          <div className="card-body">
                            <h1 className="card-title">{data.contributor_total_datasets}</h1>
                            <h5 className="card-text mb-4"><i className="fa fa-file-archive-o"/> Total of your datasets</h5>
                          </div>
                        </div>
                      </div>
                    </div>

                    {
                      window.auth.is_contributor ? (
                        <table className="table table-hover">
                          <thead className="thead-dark">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Study title</th>
                              <th scope="col" className="text-right"><i className="fa fa-eye"/> Views</th>
                              <th scope="col" className="text-right"><i className="fa fa-download"/> Downloaded</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              data.stat_studies.map((d,i)=>{
                                return (
                                  <tr key={d.title}>
                                    <th scope="row">{i+1}</th>
                                    <td>{d.title}<br/><small>I would like to be offered co-authorship on any publications using my Data</small></td>
                                    <td className="text-right">{d.total_view || 0}</td>
                                    <td className="text-right">{d.total_download || 0}</td>
                                  </tr>
                                )
                              })
                            }
                          </tbody>
                        </table>
                      ) : null
                    }

                    {
                      data.contributor_downloads.length ? (
                        <>
                          <hr/><br/>
                          <h5 className="member-block-title"><i className="fa fa-list"/> Your datasets download history:</h5>
                          <table className="table table-hover">
                            <thead className="thead-dark">
                              <tr>
                                <th scope="col" style={{width:168}}>Datetime</th>
                                <th scope="col" style={{width:190}}>Downloaded by</th>
                                <th scope="col">Study title</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                data.contributor_downloads.map((d,i)=>{
                                  return (
                                    <tr key={i}>
                                      <td>{moment.utc(d.downloadDatetime).tz(moment.tz.guess()).fromNow()}
                                        <br/>
                                        <small>
                                          <b>{moment.utc(d.downloadDatetime).tz(moment.tz.guess()).format('D MMM YYYY')}</b> <i className="fa fa-clock-o"/> {moment.utc(d.downloadDatetime).tz(moment.tz.guess()).format('hh:mm a')}
                                        </small>
                                      </td>
                                      <td>
                                        <a href={`/member/account/${d.id}`}><b>{d.first_name} {d.last_name}</b></a>
                                        {
                                          d.affiliation ? (
                                            <>
                                              <br/><small>{`(${d.affiliation})`}</small>
                                            </>
                                          ) : null
                                        }
                                      </td>
                                      <td>{d.title}<br/><small>Permission: I would like to be offered co-authorship on any publications using my Data</small></td>
                                    </tr>
                                  )
                                })
                              }
                            </tbody>
                          </table>
                        </>
                      ) : null
                    }


                    <br/>
                  </div>
                </div>
              </div>
            </div>
          ) : null
        }

        <MemberFooter/>

      </section>

    </>
  )
}

export default Dashboard
